import React from "react";
import { Route } from "react-router-dom";
import { menuConfig } from "../configs/MenuConfig";
import * as CarrierPages from "../pages/carrier";
import CarrierPanel from "../pages/carrier/CarrierPanel";
import CarrierProfileEdit from "../pages/carrier/CarrierProfileEdit";
import PanelLayout from"../layouts/PanelLayout"
import ProtectedRoute from "../components/ProtectedRoute";

function renderRoutes(items = []) {
  return items.map(({ link, component, submenu }) => {
    const Page = component ? CarrierPages[component] : undefined;

    return (
      <Route key={link} path={link} element={Page ? <Page /> : undefined}>
        {submenu && renderRoutes(submenu)}
      </Route>
    );
  });
}

export default function CarrierRoutes() {
  const routes = menuConfig.carrier.items;

  return (
    <Route path="/carrier-panel" element={<ProtectedRoute allowedRoles={["carrier","admin"]}><PanelLayout user ='carrier'/></ProtectedRoute>}>
     <Route path="carrier-profile-edit" element={<CarrierProfileEdit />} />
      <Route index element={<CarrierPanel />} />
     {renderRoutes(routes)}
    </Route>
);
}